import { TdsButton } from '@scania/tegel-react'
import styled from 'styled-components'

export const ADHSelectFileButton = styled(TdsButton)`
  input[type='file'] {
    display: none;
  }
`
